import React from 'react';
import { Trophy, Clock } from 'lucide-react';

const ResultBoard = ({ lang }) => {
  const dummyResults = [
    { bazi: 1, win: 5 }, { bazi: 2, win: 3 }, { bazi: 3, win: 8 },
    { bazi: 4, win: 0 }, { bazi: 5, win: 2 }, { bazi: 6, win: 7 },
    { bazi: 7, win: 1 }, { bazi: 8, win: 4 }, { bazi: 9, win: 9 },
    { bazi: 10, win: "442" } // 10th Bazi with Patti
  ];

  return (
    <div className="bg-white border-b-4 border-orange rounded-3xl shadow-2xl overflow-hidden sticky top-24">
      <div className="bg-navy p-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Trophy className="text-amazon-yellow" size={20} />
          <h3 className="text-white font-black italic tracking-tighter">
            {lang === 'bn' ? 'লাইভ রেজাল্ট' : 'LIVE RESULTS'}
          </h3>
        </div>
        <div className="flex items-center gap-1 text-[10px] text-green-400 font-bold animate-pulse">
          <Clock size={12} />
          <span>UPDATED</span>
        </div>
      </div>

      <div className="p-2">
        <table className="w-full">
          <thead>
            <tr className="text-[10px] text-gray-400 uppercase tracking-widest border-b border-gray-100">
              <th className="py-3 px-2 text-left">{lang === 'bn' ? 'বাজি' : 'BAZI'}</th>
              <th className="py-3 px-2 text-right">{lang === 'bn' ? 'বিজয়ী' : 'WINNER'}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {dummyResults.map((item, i) => (
              <tr key={i} className="hover:bg-bg-gray transition-colors group">
                <td className="py-3 px-2">
                  <span className="bg-light-navy text-white text-[10px] font-bold px-2 py-1 rounded-md">
                    {item.bazi}{lang === 'bn' ? 'নং বাজি' : ' Bazi'}
                  </span>
                </td>
                <td className="py-3 px-2 text-right">
                  <span className={`font-black text-xl italic ${item.bazi === 10 ? 'text-amazon-link drop-shadow-sm' : 'text-red-600'}`}>
                    {item.win}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="bg-bg-gray p-3 text-center">
        <p className="text-[9px] text-gray-500 font-bold uppercase tracking-tighter italic">
          Kolkata Super Official Fast Result
        </p>
      </div>
    </div>
  );
};

export default ResultBoard;